// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "RewardDetailsRow__regular__SwB52";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const name = "RewardDetailsRow__name__nHvus";
export const description = "RewardDetailsRow__description__Gtj1Z";
export const amount = "RewardDetailsRow__amount__TJhZP";
export const statusCopy = "RewardDetailsRow__statusCopy__wvFjI";
export const earned = "RewardDetailsRow__earned__pkBCt";
export const dismissButtonWrapper = "RewardDetailsRow__dismissButtonWrapper__kEJGh";
export const buy = "RewardDetailsRow__buy__0IDWg";
export const sell = "RewardDetailsRow__sell__hC1L6";